var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.exitflag)?_c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"nowlogin":_vm.nowlogin}}),_vm._v(" "),(_vm.showBackToMobile)?_c('button',{staticClass:"m-back-to-mobile",on:{"click":_vm.backToMobile}},[_vm._v("手机版")]):_vm._e()],1):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/template-compiler?{"id":"data-v-f1f9d00e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 